import { BaseService } from './BaseService';

export interface LoginResponse {
  success: boolean;
  message: string;
  accessToken?: string;
  refreshToken?: string;
}

export interface RegisterPayload {
  accountType?: 'INDIVIDUAL' | 'BUSINESS' | 'CUSTOMER' | string;
  userName?: string;
  firstName?: string;
  lastName?: string;
  businessName?: string;
  registrationNumber?: string;
  legalForm?: string;
  email: string;
  phoneNumber: string;
  password?: string;
}

export interface RegisterResponse {
  success: boolean;
  message: string;
}

export interface VerifyResponse {
  success: boolean;
  message: string;
}

export interface ForgotPasswordResponse {
  success: boolean;
  message: string;
}

export interface ChangePasswordPayload {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface ChangePasswordResponse {
  success: boolean;
  message: string;
}

class AuthService extends BaseService {
  constructor() {
    super('/api/v1/auth');
  }

  async login(data: any): Promise<LoginResponse> {
    return this.post<LoginResponse>('/login', data);
  }

  async register(data: RegisterPayload): Promise<RegisterResponse> {
    return this.post<RegisterResponse>('/register', data);
  }

  async refresh(token: string): Promise<LoginResponse> {
    return this.post<LoginResponse>('/refresh', { token });
  }

  async verifyRegistration(token: string): Promise<VerifyResponse> {
    return this.post<VerifyResponse>(`/register/verify/${token}`, { token });
  }

  async forgotPassword(identifier: string): Promise<ForgotPasswordResponse> {
    return this.post<ForgotPasswordResponse>('/forgot-password', { identifier });
  }

  async changePassword(data: ChangePasswordPayload): Promise<ChangePasswordResponse> {
    return this.post<ChangePasswordResponse>('/change-password', data);
  }
}

export const authService = new AuthService();


